/**
 * Malwarebytes Browser Guard
 *
 * Nearly all of its 39 web-accessible resources use `use_dynamic_url: true`, which
 * defeats fixed-URL probing. The two exceptions — the account popup UI — are static,
 * but scoped to `https://my.malwarebytes.com/*`.
 *
 * So this extension IS detectable, but only by Malwarebytes' own site. From any other
 * origin the resources are unreachable and a negative result proves nothing. That's
 * close to the correct way to expose a resource, and a useful contrast with the
 * extensions that hand the same capability to `<all_urls>`.
 *
 * Manifest verified against version 3.3.1.
 */

import { probeFetch } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';

const ID = 'ihcjicgdanjaechkgeegckofjjedodee';

export const malwarebytes: ExtensionDefinition = {
  id: ID,
  name: 'Malwarebytes Browser Guard',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 11_000_000,
  requiredOrigin: 'https://my.malwarebytes.com',
  notes:
    'Uses use_dynamic_url for 39 of 41 resources. The two static ones are scoped to ' +
    'my.malwarebytes.com, so only that site can detect it — a good example of the ' +
    'mitigation applied properly.',
  signals: [
    {
      id: 'war-popup-index',
      kind: 'web-accessible-resource',
      description:
        'Fetch app/popup/index.html — static, but only exposed to my.malwarebytes.com.',
      weight: 1,
      run: () => probeFetch(ID, 'app/popup/index.html'),
    },
    {
      id: 'war-popup-css',
      kind: 'web-accessible-resource',
      description: 'Fetch app/popup/popup.css — the other origin-scoped static resource.',
      weight: 0.5,
      run: () => probeFetch(ID, 'app/popup/popup.css'),
    },
  ],
};
